import { render } from "./ListUserMotherById.vue?vue&type=template&id=4bda41c8&scoped=true"
import script from "./ListUserMotherById.vue?vue&type=script&lang=js"
export * from "./ListUserMotherById.vue?vue&type=script&lang=js"

import "./ListUserMotherById.vue?vue&type=style&index=0&id=4bda41c8&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bda41c8"]])

export default __exports__